import { COVERAGE_STATUS_LABEL } from '@/modules/projects/components/StatementCoverage/constants'
import type { CoverageStatus } from '@/modules/projects/components/StatementCoverage/types'
import {
  type MapCell as Cell,
  cellMonthName,
} from '@/modules/projects/components/Workbench/map'
import {
  fadedClass,
  type Highlight,
  type MapActions,
} from '@/modules/projects/components/Workbench/mapView'
import { cn } from '@/utils'
import { cellClass, cellContent } from './cell'
import { GapCell } from './GapCell'

interface MapCellProps {
  cell: Cell
  gridRow: number
  laneLabel: string
  choosing: boolean
  highlight: Highlight
  actions: MapActions
}

// A month with no statement was judged on its neighbours, so a click shows them instead of
// starting an empty statement.
const isGap = (coverage: CoverageStatus | null) =>
  coverage === 'missing' || coverage === 'verified_gap'

// An empty month inside the account's span carries that month's coverage state; one outside it is
// just a place to file pages.
export const MapCell = ({
  cell,
  gridRow,
  laneLabel,
  choosing,
  highlight,
  actions,
}: MapCellProps) => {
  const month = cell.coverage
  const coverage = month?.status ?? null
  return (
    <div
      className={cn('@container h-8', fadedClass(highlight, coverage))}
      style={{ gridColumn: cell.monthIndex + 2, gridRow }}
    >
      {month && !choosing && isGap(coverage) ? (
        <GapCell laneLabel={laneLabel} month={month} actions={actions} />
      ) : (
        <button
          type="button"
          data-drop-target
          onClick={() => actions.onPutInNew(cell)}
          className={cellClass(choosing, coverage)}
          title={
            choosing
              ? `Put the selected pages in a new statement here: ${laneLabel}, ${cellMonthName(cell)}`
              : `${coverage ? `${COVERAGE_STATUS_LABEL[coverage]}. ` : ''}Pick pages to start a statement here: ${laneLabel}, ${cellMonthName(cell)}`
          }
        >
          {cellContent(coverage)}
        </button>
      )}
    </div>
  )
}
